<div class="d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center gap-3 w-100">
    <div class="flex-fill"></div>
  </div>
</div>

<div class="filters-box">
  <app-rental-select
    [inline]="true"
    [ctrl]="filters.get('rentals')"
    i18n-matTooltip
    i18n-placeholder
    placeholder="Rentals"
    matTooltip="Filter the below rates by rental."
  >
  </app-rental-select>
  <mat-form-field2
    class="field-categories"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by category."
    matTooltipPosition="above"
  >
    <mat-select [formControl]="filters.get('category')" i18n-placeholder placeholder="Category">
      <mat-option value="*" i18n>All categories</mat-option>
      <mat-option *ngFor="let category of categories$ | async" [value]="category">{{ category }}</mat-option>
    </mat-select>
  </mat-form-field2>

  <mat-form-field2
    class="field-period"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by period."
    matTooltipPosition="above"
  >
    <app-mat-daterange-input placeholder="Rate Period" [formControl]="filters.get('period')"></app-mat-daterange-input>
  </mat-form-field2>

  <app-cancel-filters
    [isFiltering]="filters | isFiltering"
    (clear)="clearFilters()"
    [filterControl]="filters"
  ></app-cancel-filters>

  <app-button
    (click)="onRefresh()"
    icon="far fa-sync"
    class="btn btn-secondary-primary"
    [loading]="isRefreshing$ | async"
    i18n-matTooltip
    matTooltip="Refresh"
    matTooltipPosition="above"
  >
  </app-button>

  <div class="flex-fill"></div>

  <app-table-search
    #search
    (search)="onSearch($event)"
    [ctrl]="filters.get('search')"
    i18n-matTooltip
    matTooltip="Search by any values visible in the table below"
    matTooltipPosition="above"
  ></app-table-search>

  <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-warning dropdown-toggle" dropdownToggle>
      <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li>
        <button
          type="button"
          (click)="onDeleteSelected()"
          [disabled]="!isAnySelected()"
          i18n-matTooltip
          matTooltip="Delete selected rates."
          matTooltipPosition="left"
        >
          <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
        </button>
      </li>
    </ul>
  </div>

  <button type="button" class="btn btn-secondary-info" (click)="onAdd()">
    <span class="far fa-plus"></span> <ng-container i18n>Add Dynamic Rate</ng-container>
  </button>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="period" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            (change)="onMasterToggle($event?.checked)"
            class="master-toggle"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rental">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rental</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-rental-name [rentalId]="element.rentalId" [image]="true"></app-rental-name>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            i18n-matTooltip
            matTooltip="Rate categories are used to group multiple rates together. Rates in a Rate Category cannot overlap. When updating a channel you push a single rate category. All rates in that category will be pushed to the channel."
            matTooltipPosition="above"
          >
            <ng-container i18n>Category</ng-container> <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="period">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rate Period</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.start | epochUTC : 'MMM D, YYYY' }} - {{ element.end | epochUTC : 'MMM D, YYYY' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Rate</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div
            class="text-truncate"
            [matTooltip]="
              (element.lowRate | rate : currency : false) + ' - ' + (element.highRate | rate : currency : false)
            "
          >
            {{ element.lowRate | rate : currency : false }} -
            {{ element.highRate | rate : currency : false }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="minimumStay">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Min Stay</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.minimumStay }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="touch">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Updated</ng-container></mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.touch | epoch : 'datetime'">
          {{ element.touch | epoch : 'date' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef i18n> EDIT</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button">
                  <i class="fal fa-edit"></i><ng-container i18n>Edit</ng-container>
                </button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button">
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onEdit(row)"
        class="clickable"
        matTooltipPosition="above"
      >
      </mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
